import { Component, OnInit, ViewChild } from '@angular/core';
import {
  FormArray,
  FormControl,
  FormGroup,
  Validators,
  NgForm
} from '@angular/forms';

import { Observable } from 'rxjs/Observable';
import { ActivatedRoute, Router } from '@angular/router';
import { AtbHomeService } from '../../../services/atbHome.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FileUploader, FileUploaderOptions, FileItem } from 'ng2-file-upload';
import { FileSelectDirective, FileDropDirective } from 'ng2-file-upload/ng2-file-upload';
import swal2 from 'sweetalert2';
import { TypeaheadModule } from 'ngx-bootstrap';


import { environment } from '../../../../environments/environment';



const URL = environment.restBaseUrl + 'UploadAllegatiPermessiTuristici?id=';
const AUTHTOKEN = localStorage.getItem("token");
const HEADER = 'X-Auth-Token';

declare var jQuery: any;



@Component({
  selector: 'app-hoteliers-structures-management',
  templateUrl: './hoteliers-structures-management.component.html',
  styleUrls: ['../../../app.component.css']
})


export class HoteliersStructuresManagementComponent implements OnInit {



  selected: string;
  states: string[] = [
    'Alabama',
    'Alaska',
    'Arizona',
    'Arkansas',
    'California',
    'Colorado',
    'Connecticut',
    'Delaware',
    'Florida',
    'Georgia',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Dakota',
    'North Carolina',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Vermont',
    'Virginia',
    'Washington',
    'West Virginia',
    'Wisconsin',
    'Wyoming'
  ];



checkInlist
  kindTitle
  kindManage;
  errorMessage;
  data;
  room;
  stopsVisible;
  dataStops: any[] = new Array()
  stopsPermission
  permessiTransito
  permessiSostaDefault
  permitsBasePath
  kindHotelsPath
  kind: any[] = new Array()

  zoneData: string[] = new Array()
  areaData: any[] = new Array()
  pathZone;
  indirizzo;
  idAreaSosta;
  idTipologia


  idStructure;
  serviceToCallPath = 'strutture';
  @ViewChild('structureForm') formStructure: NgForm;

  public uploader: FileUploaderCustom = new FileUploaderCustom({ url: URL, authTokenHeader: HEADER, authToken: AUTHTOKEN }, this);
  public hasBaseDropZoneOver = false;
  public hasAnotherDropZoneOver = false;

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;

  }

  // tslint:disable-next-line:max-line-length
  constructor( private spinner: NgxSpinnerService, private router: Router, private route: ActivatedRoute, private atbService: AtbHomeService) {

    // tslint:disable-next-line:triple-equals
    if (route.snapshot.toString().indexOf('new') != -1) {
      this.kindTitle = 'Registra';
      this.kindManage = 1;
  } else {
    this.kindTitle = 'Modifica'
    this.kindManage = 0;

    if (localStorage.getItem('dataPassed') == '' ) {
      this.router.navigate(['/hoteliers/structure/structures']);
      return;
    }


    this.data = JSON.parse(localStorage.getItem('dataPassed'));

    this.idStructure = this.data['id'];
    this.room = this.data['totaleCamere']
    this.selected  =  this.data['descrizioneAreaSosta']
    this.permessiTransito  = this.data['maxPermessiTransito']
    this.indirizzo = this.data['indirizzo']
    this.idAreaSosta = this.data['idAreaSosta']
    this.idTipologia = this.data['idTipologia']


    this.stopsPermission = this.data['maxPermessiSosta']
    console.log('OGGETTO ARRIVATO', this.data);
    localStorage.setItem('dataPassed', '')


  }  }



isPrensentInTheList(selected) {
  var arraycontainsturtles = (this.zoneData.indexOf(selected) > -1);
  this.checkInlist = arraycontainsturtles

  return arraycontainsturtles;
}

onChangeRoom(number) {
  console.log(number)
  this.stopsVisible = true

  if (number  <=  5) {
    this.permessiSostaDefault = 1
  }
  if (number  >  5  && number <= 10) {
    this.permessiSostaDefault = 2
  }
  if (number  >  10  && number <= 15) {
    this.permessiSostaDefault = 3
   }
   if (number  >  15) {
    this.permessiSostaDefault = 4
   }

}

  manageStructure() {

    var id = 0;

if (this.kindManage == 1 ) {

  this.spinner.show()
  this.data = this.formStructure.value;

  console.log(this.data)

  id =  this.getIdZone(this.selected)


  this.data['idAreaSosta'] = id



  this.data['desTipologia']  = this.getKindName(this.data['idTipolgia'])
 // this.data["status"]  = "1"
 this.data['id']  = null

 this.data['maxPermessiSosta']  = this.permessiSostaDefault


 this.data['maxPermessiTransito'] = this.data['totaleCamere'];

 console.log("OGGETTO DA INVIARE", this.data)
  this.atbService
  .newObject(this.data, this.permitsBasePath + '/' + this.serviceToCallPath)
  .subscribe(
    response => {
      console.log('Console', response);
      if (response.outcome.success === true) {
       // swal2("Nuovo veicolo creato", "", "success");

       this.multipleUpload(response.result.id)
       this.router.navigate(['/hoteliers/structure/structures']);
       this.spinner.hide()
      } else {
        this.errorMessage = 'Credenziali non valide.';
     //   swal2("Attenzione", "Credenziali non valide", "warning");
     this.spinner.hide()
      }
    },
    error => {
   //   this.logger.log("Error", error, 200);
      this.errorMessage = 'Spiacente, si è verificato un errore tecnico.';
    /*  swal2(
       "Errore",
        "Spiacente, si è verificato un errore tecnico.",
        "error"
      );*/
      this.spinner.hide()
    }
  );

} else {

  this.spinner.show()
  this.data = this.formStructure.value;
  this.data['totaleCamere'] = this.room;
  this.data['maxPermessiSosta']  = this.stopsPermission
  this.data['maxPermessiTransito']  = this.permessiTransito
  this.data['idTipologia']  = this.idTipologia
  this.data['idAreaSosta']  = this.idAreaSosta
  this.data['indirizzo']  = this.indirizzo

  console.log()
  this.data['desTipologia']  = this.getKindName(this.data['idTipolgia'])








  this.data['id']  = this.idStructure;
  this.atbService.edit(this.data, this.permitsBasePath + '/' + this.serviceToCallPath).subscribe(
    response => {
      if (response.outcome.success === true) {
        this.router.navigate(['/hoteliers/structure/structures']);
       // swal2("Il veicolo è stato modificato", "", "success");

       if (this.uploader.queue.length > 0 ) {
        this.multipleUpload(this.data['id'])
       }

      this.spinner.hide()


      } else {
        this.errorMessage =
          response.outcome.code + response.outcome.description;
       // swal2('Attenzione', this.errorMessage, 'warning');
       this.spinner.hide()
      }
    },
    error => {
      // this.logger.log("Error", error, 200);
      this.errorMessage = 'Spiacente, si è verificato un errore tecnico.';
      this.spinner.hide()
    }
  );
}

  }

getKindName(id){
  var result;
  console.log("ID", id)
  console.log("LISTA TIPOLIGIA", this.kind)
  for(let s of this.kind) {
    if(s.id == id){
result = s.descrizione
    }
  }
  return result
}



  ngOnInit() {
    this.checkInlist = false
    this.stopsVisible = false;
    this.permitsBasePath = "permessituristici"
    this.kindHotelsPath = "tipologiestrutture"
    this.kindHotelsList()
    this.pathZone = 'areesosta';
    this.kindZoneList()
  }

  back() {
    this.router.navigate(['/hoteliers/structure/structures']);
  }


  open() {
    jQuery('#sidebar').toggleClass('active');

  console.log('press')
  }



  multipleUpload(idStr) {

  //  swal2("Caricamento file", "Il file è stato caricato correttamente", "success")


  //    this.uploader.options.additionalParameter = {
      //  codeDocumentType: code,
    //    id: idStr,
      //  dtReleased: this.dateForm.value.emissionDocument.formatted,
      //  dtValidityStart: this.dateForm.value.beginValidity.formatted,
      //  dtValidityEnd: this.dateForm.value.endValidity.formatted
 //     }


    this.uploader.uploadAllFiles(idStr);

  }




  kindZoneList() {


    this.atbService.getListFilter(this.permitsBasePath + '/' + this.pathZone).subscribe(
      (response) => {
      // Verificare outcome
      if (response.outcome.success === true) {
        this.areaData = response.results
        for (let k of this.areaData) {
          var string = ""
          string =  k.descrizione

          this.zoneData.push(string)

        }

      console.log('Lista Tipologie Hotel', this.zoneData);
    } else {

    }

      },
      (error) => {
        console.log('Error ', error);
       // this.goToAtbAtHome();
      }
      );

  }




  getIdZone(string) {

    var id = 0;

for (let z of this.areaData) {
  if (z.descrizione == string) {
id = z.id
  }

}

return id;
  }







  kindHotelsList() {


    this.atbService.getListFilter(this.permitsBasePath + '/' + this.kindHotelsPath).subscribe(
      (response) => {
      // Verificare outcome
      if (response.outcome.success === true) {
        this.kind = response.results





      console.log('Lista Tipologie Hotel', this.kind);
    } else {

    }

      },
      (error) => {
        console.log('Error ', error);
       // this.goToAtbAtHome();
      }
      );

  }

}

export class Stops {
  id;
  constructor() {  }

}

export class FileUploaderCustom extends FileUploader {

  structure: HoteliersStructuresManagementComponent;


  constructor(options: FileUploaderOptions, str: HoteliersStructuresManagementComponent) {
    super(options);
    this.structure = str
  }


  uploadAllFiles ( idStr): any {

   swal2({
      title: 'Caricamento documento in corso...',
      onOpen: function () {
        swal2.showLoading()
      }
    })

    var xhr = new XMLHttpRequest();
    var sendable = new FormData();
    var fakeitem: FileItem = null;
    this.onBuildItemForm(fakeitem, sendable);
    var response: any

    for (const item of this.queue) {
      item.isReady = true;
      item.isUploading = true;
      item.isUploaded = false;
      item.isSuccess = true;
      item.isCancel = false;
      item.isError = false;
      item.progress = 0;
      item.withCredentials = false;

      if (typeof item._file.size !== 'number') {
        throw new TypeError('The file specified is no longer valid');
      }
      sendable.append('file', item._file, item.file.name);
    }

    if (this.options.additionalParameter !== undefined) {
      Object.keys(this.options.additionalParameter).forEach((key) => {
        sendable.append(key, this.options.additionalParameter[key]);
      });
    }

    xhr.onload = () => {
      var gist = (xhr.status >= 200 && xhr.status < 300) || xhr.status === 304 ? 'Success' : 'Error';
      var method = 'on' + gist + 'Item';
      this[method](fakeitem, null, xhr.status, null);

    };
    xhr.onerror = () => {
      this.onErrorItem(fakeitem, null, xhr.status, null);
    };




    xhr.onabort = () => {
      this.onErrorItem(fakeitem, null, xhr.status, null);
    };

    this.options.url = URL + idStr
    xhr.open('POST', this.options.url, true);
    xhr.withCredentials = false;
    if (this.options.headers) {
      for (var _i = 0, _a = this.options.headers; _i < _a.length; _i++) {
        var header = _a[_i];

        header.name = 'X-Auth-Token' ;
        header.value  = localStorage.getItem('token')

        xhr.setRequestHeader(header.name, header.value);
      }
    }

    this.authToken = localStorage.getItem('token');

    console.log ( 'Token', this.authTokenHeader + ' : '  + this.authToken )
  if (this.authToken) {
      xhr.setRequestHeader(this.authTokenHeader, this.authToken);
    }
    xhr.send(sendable);



    return xhr.onloadend = () => {

      console.log(xhr.response)
   //   var res = JSON.parse(xhr.response);
      if (xhr.response == 'OK-Allegato caricato con successo!') {

        swal2('Caricamento file', 'Il file è stato caricato correttamente', 'success')

        //this.structure.getListDocuments();
        this.structure.uploader.queue = [];

        return xhr.response
      } else {
        var msgTxt;

          msgTxt = 'Un file con questo nome è già presente';

        swal2('Errore', msgTxt , 'error');

       // this.docComponent.getListDocuments();
        this.structure.uploader.queue = [];
      //  this.docComponent.codeControlUpload = "ND"
        return xhr.response
      }



    }








  };

}





// WEBPACK FOOTER //
// ./src/app/views/hoteliers-permits/hoteliers-structures-management/hoteliers-structures-management.component.ts